import React from 'react';
import type { Props } from './types.tsx';

const AsyncIconImportCond = importCond<
	typeof import('./MemoedAsyncIcon.tsx'),
	typeof import('./view-old.tsx')
>('vc90_async_icon_general_perf_improvements', './MemoedAsyncIcon.tsx', './view-old.tsx');

const AsyncIcon = (props: Props) => <AsyncIconImportCond {...props} />;

// Needed for snapshot tests to work correctly
AsyncIcon.displayName = 'AsyncIcon';

export default AsyncIcon;
